module.exports = __webpack_public_path__ + "img/Johnson&Johnson.e417ac44.jpg";